import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=4d3cbc90&scoped=true&"
import script from "./PageTitle.vue?vue&type=script&lang=ts&"
export * from "./PageTitle.vue?vue&type=script&lang=ts&"
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=4d3cbc90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3cbc90",
  null
  
)

export default component.exports